import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import React from 'react';
import types from 'prop-types';
import momentTypes from 'react-moment-proptypes';
import { nonNegativeInteger } from 'airbnb-prop-types';
import moment from 'moment';
import { compose, onlyUpdateForKeys } from 'recompose';
import { styled } from '@rexlabs/styling';
import styles from '../styles/calendar-month';
import CalendarDay from './calendar-day';
import getCalendarMonthWeeks from '../utils/getCalendarMonthWeeks';
import isSameDay from '../utils/isSameDay';
import toISODateString from '../utils/toISODateString';
import ScrollableOrientationShape from '../shapes/ScrollableOrientationShape';
import DayOfWeekShape from '../shapes/DayOfWeekShape';
import { HORIZONTAL_ORIENTATION, DAY_SIZE } from '../constants';
var assign = _Object$assign;

var CalendarMonth = function CalendarMonth(_ref) {
  var _styles;

  var month = _ref.month,
      monthFormat = _ref.monthFormat,
      orientation = _ref.orientation,
      enableOutsideDays = _ref.enableOutsideDays,
      firstDayOfWeek = _ref.firstDayOfWeek,
      isVisible = _ref.isVisible,
      modifiers = _ref.modifiers,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      renderMonth = _ref.renderMonth,
      renderDay = _ref.renderDay,
      daySize = _ref.daySize,
      focusedDate = _ref.focusedDate,
      isFocused = _ref.isFocused,
      dateIsUnavailableLabel = _ref.dateIsUnavailableLabel,
      Container = _ref.Container,
      Month = _ref.Month,
      Grid = _ref.Grid,
      Title = _ref.Title,
      Week = _ref.Week,
      styles = _ref.styles;
  var weeks = getCalendarMonthWeeks(month, enableOutsideDays, !firstDayOfWeek ? moment.localeData().firstDayOfWeek() : firstDayOfWeek);
  return React.createElement(Container, _extends({}, styles((_styles = {
    container: true
  }, _defineProperty(_styles, orientation, true), _defineProperty(_styles, "isVisible", isVisible), _styles)), {
    "data-type": "month",
    "data-visible": isVisible
  }), React.createElement(Month, styles('month'), React.createElement(Title, _extends({}, styles(_defineProperty({
    title: true
  }, "title_".concat(orientation), true)), {
    "data-type": "caption"
  }), renderMonth ? renderMonth(month) : month.format(monthFormat)), React.createElement(Grid, _extends({}, styles('grid'), {
    "data-type": "grid"
  }), weeks.map(function (week, i) {
    return React.createElement(Week, _extends({}, styles('week'), {
      key: i
    }), week.map(function (day, dayOfWeek) {
      return React.createElement(CalendarDay, {
        day: day,
        daySize: daySize,
        isOutsideDay: !day || day.month() !== month.month(),
        tabIndex: isVisible && isSameDay(day, focusedDate) ? 0 : -1,
        isFocused: isFocused,
        key: dayOfWeek,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        renderDay: renderDay,
        dateIsUnavailableLabel: dateIsUnavailableLabel,
        modifiers: modifiers[toISODateString(day)]
      });
    }));
  }))));
};

var meta = {
  displayName: 'CalendarMonth',
  propTypes: {
    month: momentTypes.momentObj,
    isVisible: types.bool,
    enableOutsideDays: types.bool,
    modifiers: types.object,
    orientation: ScrollableOrientationShape,
    daySize: nonNegativeInteger,
    onClick: types.func,
    onMouseEnter: types.func,
    onMouseLeave: types.func,
    renderMonth: types.func,
    renderDay: types.func,
    firstDayOfWeek: DayOfWeekShape,
    focusedDate: momentTypes.momentObj,
    isFocused: types.bool,
    monthFormat: types.string,
    dateIsUnavailableLabel: types.string,
    Container: types.oneOfType([types.string, types.func]),
    Month: types.oneOfType([types.string, types.func]),
    Grid: types.oneOfType([types.string, types.func]),
    Title: types.oneOfType([types.string, types.func]),
    Week: types.oneOfType([types.string, types.func])
  },
  defaultProps: {
    month: moment(),
    isVisible: true,
    enableOutsideDays: false,
    modifiers: {},
    orientation: HORIZONTAL_ORIENTATION,
    daySize: DAY_SIZE,
    onClick: function onClick() {},
    onMouseEnter: function onMouseEnter() {},
    onMouseLeave: function onMouseLeave() {},
    isFocused: false,
    monthFormat: 'MMMM YYYY',
    Container: 'div',
    Month: 'table',
    Grid: 'tbody',
    Title: 'caption',
    Week: 'tr'
  }
};

var _CalendarMonth = assign(CalendarMonth, meta);

export default assign(compose(onlyUpdateForKeys(['month', 'enableOutsideDays', 'firstDayOfWeek', 'isFocused', 'focusedDate', 'isVisible', 'modifiers']), styled(styles))(_CalendarMonth), meta);